import request from "./request";

//刷新token
export function refreshToken(params) {
  return request({
    url: "/bjweb/refreshToken",
    params,
    method: "post",
    isToken: true,
  });
}

// 获取密码公钥
export function getPublicKey() {
  return request({
    url: "/bjweb/publicKey",
    method: "get",
  });
}

// 获取手机号验证码
export function getCode(phone) {
  return request({
    url: "/bjweb/sms/s/" + phone,
    method: "get",
    isToken: true,
  });
}

// 获取手机号验证码
export function getLoginCode(phone, vCode) {
  return request({
    url: `/bjweb/sms/login/code/${phone}/${vCode}`,
    method: "get",
  });
}

// 获取手机号验证码
export function getRegisterCode(phone, vCode) {
  return request({
    url: `/bjweb/sms/register/code/${phone}/${vCode}`,
    method: "get",
  });
}

// 通过token获取验证码 type: 0=手机验证码 1=邮箱验证码
export function smsSend(type) {
  return request({
    url: `/bjweb/sms/s?type=${type !== undefined ? type : 0}`,
    method: "get",
    isToken: true,
  });
}

// 注册
export function register(data) {
  return request({
    url: "/bjweb/client/reg",
    method: "post",
    data,
  });
}

// 登录
export function login(data) {
  return request({
    url: "/bjweb/login",
    method: "post",
    data,
  });
}

// 账户金额
export function getAmountInfo() {
  return request({
    url: "/bjweb/client/user/info",
    method: "get",
    isToken: true,
  });
}

// 账户首页
export function getUserIndex() {
  return request({
    url: "/bjweb/client/user/index",
    method: "get",
    isToken: true,
  });
}

// 个人资料
export function getMemberInfo() {
  return request({
    url: "/bjweb/client/me",
    method: "get",
    isToken: true,
  });
}

// 忘记密码账号校验
export function forgetPwdVerify(params) {
  return request({
    url: "/bjweb/forgetPwdVerify",
    params,
    method: "get",
  });
}

// 获取修改密码短信
export function verifyCode(verifyCode) {
  return request({
    url: `/bjweb/sms/verCode/${verifyCode}`,
    method: "get",
  });
}

// 获取修改密码短信
export function postVerifyCode(data) {
  return request({
    url: `/bjweb/sms/verCode`,
    data,
    method: "post",
    isToken: true,
  });
}

//验证验证码
export function forgetPwdVerifySmsCode(params) {
  return request({
    url: "/bjweb/forgetPwdVerifySmsCode",
    params: { ...params },
    method: "post",
  });
}

//忘记密码修改密码
export function forgetPwdChange(data) {
  return request({
    url: "/bjweb/forgetPwdChange",
    data,
    method: "post",
  });
}

// 账户首页
export function userInfo() {
  return request({
    url: "/bjweb/client/user/index",
    method: "get",
    isToken: true,
  });
}

// 上传头像
export function uploadPicture(data) {
  return request({
    url: "/bjweb/upload/image",
    data,
    method: "post",
    isToken: true,
  });
}

// 个人资料修改
export function userEdit(data) {
  return request({
    url: "/bjweb/client/update",
    data,
    method: "post",
    isToken: true,
  });
}

// 我的认证信息
export function securityCenter() {
  return request({
    url: "/bjweb/client/safe",
    method: "get",
    isToken: true,
  });
}

// 身份认证保存
export function userIdentitySave(data) {
  return request({
    url: "/bjweb/renzhen/saveVerifySFZ",
    data,
    method: "post",
    isToken: true,
  });
}

// 修改密码
export function userPwdUpdate(data) {
  return request({
    url: "/bjweb/client/pwd/change",
    data,
    method: "post",
    isToken: true,
  });
}

// 设置邮箱
export function userEmailAdd(data) {
  return request({
    url: "/bjweb/client/email/save",
    data,
    method: "post",
    isToken: true,
  });
}

// 修改邮箱
export function userEmailUpdate(data) {
  return request({
    url: "/bjweb/client/email/update",
    data,
    method: "post",
    isToken: true,
  });
}

// 邮箱认证
export function userVerifyEmail(params) {
  return request({
    url: "/bjweb/renzhen/verifyEmail",
    params,
    method: "get",
    isToken: true,
  });
}

// 修改手机号
export function userMobileUpdate(data) {
  return request({
    url: "/bjweb/client/ph/change",
    data,
    method: "post",
    isToken: true,
  });
}

// 我的认证
export function myCertification() {
  return request({
    url: "/bjweb/renzhen/myVerify",
    method: "get",
    isToken: true,
  });
}

// 个人认证认证列表
export function userIdentityList(params) {
  return request({
    url: "/bjweb/renzhen/getVerifies",
    params,
    method: "get",
    isToken: true,
  });
}

// 企业认证保存
export function enterpriseIdentitySave(data) {
  return request({
    url: "/bjweb/renzhen/saveCompanyVerify",
    data,
    method: "post",
    isToken: true,
  });
}

// 个人认证删除
export function userIdentityDelete(data) {
  return request({
    url: `/bjweb/renzhen/deleteVerifySFZ/${data}`,
    method: "DELETE",
    isToken: true,
  });
}

// 企业认证
export function enterpriseIdentityList(params) {
  return request({
    url: "/bjweb/renzhen/getVerifyCompany",
    params,
    method: "get",
    isToken: true,
  });
}

// 企业认证认证图片
export function enterpriseIdentityUpload(data) {
  return request({
    url: `/bjweb/renzhen/verifyCompanyImage`,
    data,
    method: "post",
    isToken: true,
  });
}

// 企业认证删除
export function enterpriseIdentityDelete(data) {
  return request({
    url: `/bjweb/renzhen/deleteCompanyVerify/${data}`,
    method: "DELETE",
    isToken: true,
  });
}

// 邮箱认证
export function certifiedEmailList(params) {
  return request({
    url: "/bjweb/renzhen/getEmailVerify",
    params,
    method: "get",
    isToken: true,
  });
}

// 邮箱删除
export function certifiedEmailDelete(data) {
  return request({
    url: `/bjweb/renzhen/deleteEmailVerify/${data}`,
    method: "DELETE",
    isToken: true,
  });
}

// 重新发送邮箱认证
export function certifiedEmailSendEmail(data) {
  return request({
    url: `/bjweb/renzhen/sendVerifyEmail`,
    params: { ...data },
    method: "post",
    isToken: true,
  });
}

// 登录日志
export function loginLogList(params) {
  return request({
    url: "/bjweb/log",
    params,
    method: "get",
    isToken: true,
  });
}

// 充值接口
export function payRecharge(data) {
  return request({
    url: `/bjweb/pay/recharge`,
    data,
    method: "post",
    isToken: true,
  });
}

// 获取银行卡列表
export function bankCardList(params) {
  return request({
    url: "/bjweb/bk/gets",
    params,
    method: "get",
    isToken: true,
  });
}

// 添加银行卡
export function createBankCard(data) {
  return request({
    url: `/bjweb/bk/add`,
    data,
    method: "post",
    isToken: true,
  });
}

// 获取银行卡名称
export function getBankName(params) {
  return request({
    url: "/bjweb/bk/name/" + params,
    params,
    method: "get",
    isToken: true,
  });
}

// 银行卡删除
export function bankCardDelete(data) {
  return request({
    url: `/bjweb/bk/delete/${data}`,
    method: "DELETE",
    isToken: true,
  });
}

// 获取提现比例
export function userLevel(params) {
  return request({
    url: "/bjweb/client/rate",
    params,
    method: "get",
    isToken: true,
  });
}

// 提现申请
export function withdraw(data) {
  return request({
    url: `/bjweb/withdrawal/save`,
    data,
    method: "post",
    isToken: true,
  });
}

// 提现记录
export function withdrawalPageList(params) {
  return request({
    url: "/bjweb/withdrawal/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 取消申请提现
export function cancelCashOut(withdrawalId) {
  return request({
    url: "/bjweb/withdrawal/" + withdrawalId,
    method: "PATCH",
    isToken: true,
  });
}

// 财务类型
export function financeTypeList(params) {
  return request({
    url: "/bjweb/client/financial",
    params,
    method: "get",
    isToken: true,
  });
}

// 资金明细
export function financeList(params) {
  return request({
    url: "/bjweb/client/capital",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取发票列表
export function invoiceList(params) {
  return request({
    url: "/bjweb/invoice/pageList",
    params,
    method: "get",
    isToken: true,
  });
}

// 取消发票申请
export function invoiceCancel(data) {
  return request({
    url: `/bjweb/invoice/cancel`,
    data,
    method: "post",
    isToken: true,
  });
}

// 获取发票信息查询
export function invoiceInfoList(params) {
  return request({
    url: "/bjweb/invoice/getList",
    params,
    method: "get",
    isToken: true,
  });
}

// 发票信息保存
export function invoiceInfoSave(data) {
  return request({
    url: `/bjweb/invoice/save`,
    data,
    method: "post",
    isToken: true,
  });
}

// 发票信息单个查询
export function invoiceInfoDetail(params) {
  return request({
    url: "/bjweb/invoice/getOne",
    params,
    method: "get",
    isToken: true,
  });
}

// 发票类型
export function invoiceTypeList(params) {
  return request({
    url: "/bjweb/invoice/type",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取发票数据
export function invoiceInvoiceAmountList(params) {
  return request({
    url: "/bjweb/invoice/list",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取发票总金额
export function invoiceTotalInvoiceAmount(params) {
  return request({
    url: "/bjweb/invoice/amount",
    params,
    method: "get",
    isToken: true,
  });
}

// 默认发票
export function invoiceDefault(params) {
  return request({
    url: "/bjweb/invoice/default",
    params,
    method: "get",
    isToken: true,
  });
}

// 发票信息查询全部
export function invoiceInfoMore(params) {
  return request({
    url: "/bjweb/invoice/getAll",
    params,
    method: "get",
    isToken: true,
  });
}

// 发票信息申请
export function applyMakeInvoice(data) {
  return request({
    url: `/bjweb/invoice/apply`,
    data,
    method: "post",
    isToken: true,
  });
}

// 发票信息根据ID查询
export function invoiceInvoiceDetail(params) {
  return request({
    url: "/bjweb/invoice/detail",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名解析-列表
export function resolutionList(params) {
  return request({
    url: "/bjweb/domain/resolution/getList",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名解析-启用记录
export function resolutionRecordStart(data) {
  return request({
    url: `/bjweb/domain/resolution/start/record/${data}`,
    method: "post",
    isToken: true,
  });
}

// 域名解析-暂停记录
export function resolutionRecordPause(data) {
  return request({
    url: `/bjweb/domain/resolution/pause/record/${data}`,
    method: "post",
    isToken: true,
  });
}

// 域名解析-删除记录
export function resolutionRecordRemove(data) {
  return request({
    url: `/bjweb/domain/resolution/delete/record`,
    data,
    method: "DELETE",
    isToken: true,
  });
}

// 域名解析-获取记录类型、线路
export function resolutionGetRoute(params) {
  return request({
    url: "/bjweb/domain/resolution/line",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名解析-保存记录
export function resolutionSave(data) {
  return request({
    url: `/bjweb/domain/resolution/save`,
    data,
    method: "post",
    isToken: true,
  });
}

// 域名解析-修改记录
export function resolutionModify(data) {
  return request({
    url: `/bjweb/domain/resolution/update/record`,
    data,
    method: "post",
    isToken: true,
  });
}

// 获取DNS-根据ID获取
export function domainDnsList(params) {
  return request({
    url: "/bjweb/ym/getDns",
    params,
    method: "get",
    isToken: true,
  });
}

// 设置DNS-设置DNS
export function domainDnsCreate(data) {
  return request({
    url: `/bjweb/ym/updateDns`,
    data,
    method: "post",
    isToken: true,
  });
}

// 获取DNS-dns日志
export function domainDnsLogList(params) {
  return request({
    url: "/bjweb/ym/getDnsLog",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取域名信息
export function domainDetail(params) {
  return request({
    url: "/bjweb/ym/getDnInfo",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取域名证书
export function getDownloadDomainPicById(params) {
  return request({
    url: "/bjweb/ym/download",
    params,
    method: "get",
    responseType: "arraybuffer",
    isToken: true,
  });
}

// 站内信类型
export function mailSiteType() {
  return request(
    {
      url: "/bjweb/messageTemplates/siteType",
      method: "get",
      isToken: true,
    },
  );
}

// 获取站内信列表
export function mailSiteList(data) {
  return request(
    {
      url: "/bjweb/messageTemplates/siteList",
      method: "post",
      data,
      isToken: true,
    }
  );
}


// 站内信设置已读
export function mailSiteRead(data) {
  return request(
    {
      url: "/bjweb/messageTemplates/siteRead",
      method: "post",
      data,
      isToken: true,
    }
  );
}



// 删除站内信
export function mialSiteDel(data) {
  return request(
    {
      url: "/bjweb/messageTemplates/siteDel",
      method: "post",
      data,
      isToken: true,
    }
  );
}
